import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import * as $ from 'jquery';
import { ContrasenaListComponent } from './contrasena-list.component';
import { ContrasenaService } from './contrasena.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';

@Component({
  selector: 'pm-change-contrasena',
  templateUrl: './change-contrasena.component.html',
  styleUrls: ['./change-contrasena.component.sass'],
  providers: [ContrasenaService]
})
export class ChangeContrasenaComponent implements OnInit, OnDestroy, AfterViewInit {
  public pageTitle = 'CONTRASEÑA';

  error: boolean;
  errorMessage: string;

  constructor(
    public service: ContrasenaService,
    private parent: ContrasenaListComponent,
    private router: Router,
    private spinnerService: NgxSpinnerService
  ) {}

  ngOnInit() {}

  ngAfterViewInit() {
    $('body').addClass('backgroundLogin');
  }

  changePassword(): void {
    const newPass = $('input[name=newPass]').val();
    const newPassC = $('input[name=newPassC]').val();
    console.log('changePassword: newPass: ', newPass, ', newPassC: ', newPassC);
    if (newPass !== newPassC) {
      console.log('changePassword: No son iguales');
      this.error = true;
      this.errorMessage = 'La nueva contraseña y su confirmación no coinciden';
      return;
    }

    this.service.changeEmailData = {
      changePassId: $('input[name=changePassId]').val(),
      newPass: $('input[name=newPass]').val()
    };
    this.spinner();
    console.log('ChangeContrasenaComponent: changePassword: changeEmailData: ', this.service.changeEmailData);
    this.parent.showContrasena = false;
    this.parent.showConfirmContrasena = false;
    this.parent.showChangeContrasena = true;
    this.service.changePassword(this.service.changeEmailData).subscribe(
      res => {
        console.log('ChangeContrasenaComponent: changePassword: res: ', res);
        this.parent.showContrasena = false;
        this.parent.showConfirmContrasena = false;
        this.parent.showChangeContrasena = false;
        this.router.navigate(['']);
      },
      err => {
        this.error = true;
        // console.log('ChangeContrasenaComponent: beginPasswordChange: err: ', err);
        // console.log(err.error.message);
        this.errorMessage = err.error.message;
      }
    );
  }

  cancelChangePassword(): void {
    this.parent.showContrasena = false;
    this.parent.showConfirmContrasena = false;
    this.parent.showChangeContrasena = false;
    this.router.navigate(['']);
  }

  public spinner(): void {
    this.spinnerService.show();
    setTimeout(() => {
      this.spinnerService.hide();
    }, 2000);
  }

  ngOnDestroy() {}
}
